import { ApiCore } from '@/services/api/utils/core.js'

const url = 'v1/auth/validate'

const api = new ApiCore({
	create: true,
	url: url
})

export default api
